/* WebComponentLabelPrintingPrintListTsx template */
import {Fragment, h} from '@stencil/core';

const WebComponentLabelPrintingPrintListTsx = (context) => {
    let I18N = context.ref.I18N;

    return (
        <dia-grid-nested>
            <dia-grid-row>
                <dia-grid-column>
                    <Fragment>
                        { context.ref.printListData && context.ref.printListData.data ? <dia-datatable
                            api-url="/rest/datatable/getDataFromTable"
                            header={JSON.stringify(context.ref.dataTableArticlesHeader)}
                            columns={context.ref.dataTableArticlesColumns}
                            options={JSON.stringify(context.ref.dataTableArticlesOptions)}
                            server-side
                            checkboxes={context.ref.printListChoice}
                            table-class="LabelsPrintArticlesTableSource"
                            table-id="labelPrintingPrintList"
                        >
                        </dia-datatable> :
                          <Fragment>
                            { I18N.t('Keine Artikel gewählt') }
                            { !context.ref.loading && !context.ref.error ? <button
                              onClick={() => { context.ref.renderRoutePrintList(); context.ref.reloadRouterRoute(context.ref.getRouterRoute('PRINTLIST')); }}
                              type="button"
                              data-reload-button
                              data-primary-dark
                              data-refresh-button
                            >
                              <i data-icon-before="refresh"></i>
                              { I18N.t('Tabelle erneut laden!') }
                            </button> : '' }
                          </Fragment>
                        }
                    </Fragment>
                </dia-grid-column>
            </dia-grid-row>
            <dia-grid-row>
                <dia-grid-column>
                    <dia-form data-printlist-form>
                        { /* @ts-ignore */}
                        <form action="#" method="GET" name="dia-label-printing-printlist" has="validator">
                            <dia-form-line data-form-line-no-wrap data-printlist-submit>
                                <dia-form-control>
                                    <input
                                        data-datatable-target-field
                                        autocomplete="off"
                                        data-rules="required|number|min:1"
                                        data-validator-message-position="top"
                                        data-validator-message-min={ I18N.t("Bitte wählen Sie mindestens einen Artikel") }
                                        type="text" name="choosen"
                                        placeholder=""
                                        value={context.ref.printListChoice.length}
                                        readonly
                                    />
                                    <label>{ I18N.t('Ausgewählte Artikel') }</label>
                                </dia-form-control>
                                <dia-form-control>
                                    <button
                                        data-primary
                                        data-icon-only
                                        title={ I18N.t('Zur Erstellung übernehmen') }
                                        onClick={() => context.ref.submitPrintList()}
                                        disabled={!context.ref.labelPrintingPrintListFormValid}
                                    >
                                        <i data-dia-icon-before="take"></i>
                                    </button>
                                </dia-form-control>
                            </dia-form-line>
                        </form>
                    </dia-form>
                </dia-grid-column>
            </dia-grid-row>
        </dia-grid-nested>
    )
};

export default WebComponentLabelPrintingPrintListTsx;

